import React, { useState, useEffect } from 'react';
// import CmtCard from '../../../../@coremat/CmtCard';
// import CmtCardHeader from '../../../../@coremat/CmtCard/CmtCardHeader';
// import { intranet } from '../../../../@fake-db';
// import CmtCardContent from '../../../../@coremat/CmtCard/CmtCardContent';
// import ProductsList from './ProductsList';
import ProductsTable from './ProductsTable';
import Box from '@material-ui/core/Box';
import useStyles from './index.style';
import CmtCardHeader from '@coremat/CmtCard/CmtCardHeader';
import CmtCardContent from '@coremat/CmtCard/CmtCardContent';
import CmtCard from '@coremat/CmtCard';
import { Button, Collapse, Grid, MenuItem, FormControl, InputLabel, Select, TextField } from '@material-ui/core';
import { history } from 'redux/store';
import SearchIcon from '@material-ui/icons/Search';
import Close from '@material-ui/icons/Close';
import FilterList from '@material-ui/icons/FilterList';
import { httpClient } from 'appUtility/Api';

const WeeklySales = props => {
  // const { productsList } = intranet;
  const classes = useStyles();
  // const [selectedProducts, setSelectedProducts] = useState(productsList);
  // const [showChart, setShowChart] = useState(false);
  // const [filter, setFilter] = useState(false);
  // const [state, setState] = useState([]);
  // useEffect(() => {
  //   getState();
  // }, []);

  // useEffect(() => {
  //   props.submittedData.submit === true && setFilter(false);
  // }, [props.submittedData]);


  const sendTo = () => {
    // history.push('/company/addContact', {data: props.companyID});
    props.openAddContact();
  };

  // const getState = () => {
  //   httpClient.get('/state').then(({ data }) => {
  //     if (data) {
  //       setState(data.data);
  //     } else {
  //     }
  //   });
  // };

  // const handleFilterButton = () => {
  //   setFilter(prev => !prev);
  // };

  return (
    <CmtCard className={classes.cardRoot}>
      <div className={classes.tableHead}>
        <CmtCardHeader title={props.title} />
        <div className={classes.flexSearch}>
          {/* <div className={classes.formGroup}>
            <input
              placeholder="Search..."
              type="search"
              onChange={props.onChangeSearch}
              value={props.searchValue}
              onKeyPress={props.onKeyPress}
              onKeyDown={props.onKeyDown}
              className={classes.searchForm}
            />
            {!props.searchValue && <SearchIcon fontSize="small" className={classes.searchIcon} />}
          </div> */}
          {/* <Button color="secondary" variant="contained" onClick={handleFilterButton} style={{ marginRight: '10px' }}>
            <FilterList fontSize="small" /> Filter
          </Button> */}
          <Button color="primary" variant="contained" onClick={sendTo}  style={{ marginRight: '30px' }}>
            +Add Contact
          </Button>
        </div>
      </div>
      <CmtCardContent>
        {/* {filter && (
          <Collapse in={filter} className={classes.filterBox}>
            <form onSubmit={props.handleFilter}>
              <Grid container spacing={4}>
                <Grid item sm={12} md={12}>
                  <InputLabel className={classes.inputLabel}>Search </InputLabel>
                  <TextField
                    variant="outlined"
                    name="search"
                    value={props.filterData.search}
                    className={classes.text}
                    onChange={props.handleChange}
                  />
                </Grid>
                <Grid item sm={12} md={6}>
                  <InputLabel className={classes.inputLabel}>Active Suburb</InputLabel>
                  <FormControl variant="outlined" className={classes.text}>
                    <Select
                      name="suburbActive"
                      value={props.filterData.suburbActive}
                      onChange={props.handleChange}
                      className={classes.text}>
                      <MenuItem value=" ">&nbsp;</MenuItem>
                      <MenuItem value="1">Yes</MenuItem>
                      <MenuItem value="0">No</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sm={12} md={6}>
                  <InputLabel className={classes.inputLabel}>State</InputLabel>
                  <FormControl variant="outlined" className={classes.text}>
                    <Select
                      name="state"
                      // label="State"
                      value={props.filterData.state}
                      onChange={props.handleChange}
                      className={classes.text}>
                      <MenuItem value="">
                        <em>Select</em>
                      </MenuItem>
                      {state &&
                        state.map(st => (
                          <MenuItem key={st.stateID} value={st.stateName}>
                            {st.stateName}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item sm={12}>
                  <Box textAlign="right">
                    <Button color="secondary" size="small" onClick={() => setFilter(false)} style={{ marginRight: '10px' }}>
                      Cancel
                    </Button>
                    <Button color="primary" size="small" variant="contained" type="submit" style={{ marginRight: '10px' }}>
                      Filter Data
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </form>
          </Collapse>
        )} */}
        {/* {props.submittedData.suburbActive || props.submittedData.state || props.submittedData.search ? (
          <Box className={classes.productView}>
            <p>Filtered: </p>
            {props.submittedData.suburbActive && (
              <p>
                Suburb Active: <span>{props.submittedData.suburbActive == 1 ? 'Yes' : 'No'} </span>
                <Close fontSize="small" onClick={() => props.handleRemove('suburbActive')} />
              </p>
            )}
            {props.submittedData.state && (
              <p>
                State:<span> {props.submittedData.state} </span>
                <Close fontSize="small" onClick={() => props.handleRemove('state')} />
              </p>
            )}
            {props.submittedData.search && (
              <p>
                Search:<span> {props.submittedData.search} </span>
                <Close fontSize="small" onClick={() => props.handleRemove('search')} />
              </p>
            )}
          </Box>
        ) : (
          <Box className={classes.productView} />
        )} */}
        <ProductsTable
          columns={props.columns}
          selectedProducts={props.selectedProducts}
          handleEdit={props.handleEdit}
          handleActivate={props.handleActivate}
          handleDeactivate={props.handleDeactivate}
          handleDisableAccess={props.handleDisableAccess}
          handleEnableAccess={props.handleEnableAccess}
          handleResetPassword={props.handleResetPassword}
          loading={props.loading}
          handleSort={props.handleSort}
          handleChangePage={props.handleChangePage}
          handleChangeRowsPerPage={props.handleChangeRowsPerPage}
          page={props.page}
          total={props.total}
          fromTable={props.fromTable}
          toTable={props.toTable}
          rowsPerPage={props.rowsPerPage}
          currentColumn={props.currentColumn}
          direction={props.direction}
          activateTable={props.activateTable}
          enableTable={props.enableTable}
          productData={props.productData}
        />
      </CmtCardContent>
    </CmtCard>
  );
};

export default WeeklySales;
